import {chain}     from "@Common/utils/fs";
import {equalDeep} from "@Common/utils/objects";

export const applyOpacity = (c1, c2, opacity) => {
    if (opacity === 1) {
        return c1;
    }

    if (opacity === 0) {
        return c2;
    }
    // if (c2 != null && !equalDeep(c2, {r:0, g:0,b:0,a:255})) {
    //     debugger;
    // }
    // debugger;
    if (c2 == null) {
        c2 = {r:255, g:255,b:255,a:0};
    }
    const o1 = c1.a / 255 * opacity;

    const o2 = (1 - o1) * (c2.a / 255);
// console.log("o2", o2);

    const a = (v1, v2) => chain(
        // v1 * o1 + v2 * o2,
        v1 + (v2 - v1) * (o2) / (o1 + o2),
        boundColor,
    );

    c2.r = a(c1.r, c2.r);
    c2.g = a(c1.g, c2.g);
    c2.b = a(c1.b, c2.b);
    c2.a = boundColor((o1 + o2) * 255);

    return c2;
};

const boundColor = (c) => chain(
    c,
    (_) => Math.round(_),
    (_) => Math.min(255, _),
    (_) => Math.max(0, _),
);

// console.log(applyOpacity(
//     {r:255, g:255,b:255,a:255},
//     {r:0, g:0,b:0,a:255},
//     // null,
//     .5
// ));